import { Box, Divider, Flex, Text, useToast } from "@chakra-ui/react";
import React, { useContext, useEffect, useState } from "react";
import CartCard from "../Components/CartCard";
import Cartmisc from "../Components/Cartmisc";
import Contactcart from "../Components/Contactcart";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { AppContext } from "../Context/Context";
import { Dna } from "react-loader-spinner";

const Cart = () => {
  document.title = "Cart";
  const { setGrandTotal } = useContext(AppContext);
  const toast = useToast();
  const [data1, setData1] = useState([]);
  const [subtotal, setSubtotal] = useState(0);
  const [dataLoading, setDataLoading] = useState(false);
  const { token } = useContext(AppContext);

  const handleGet = () => {
    setDataLoading(true);
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    axios
      .get(`https://violent-hope.onrender.com/api/cart`, config)
      .then((res) => {
        // console.log(res.data[0].cartItems);
        window.localStorage.setItem("qty", res.data[0].cartItems.length);
        setDataLoading(false);
        setData1(res.data[0].cartItems);
      })
      .catch((err) => {
        setDataLoading(false);
        console.log(err);
      });
  };

  useEffect(() => {
    handleGet();
  }, []);

  useEffect(() => {
    const st = data1.reduce(
      (acc, elem) => acc + elem.product.price * elem.quantity,
      0
    );
    setGrandTotal(st);
    setSubtotal(st);
  }, [data1]);
  const navigate = useNavigate();

  const handleplus = (qty, id) => {
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    axios
      .patch(
        `https://violent-hope.onrender.com/api/cart`,
        { proId: id, qty: qty + 1 },
        config
      )
      .then((res) => setData1(res.data.cartItems));
  };

  const handleminus = (qty, id) => {
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    axios
      .patch(
        `https://violent-hope.onrender.com/api/cart`,
        { proId: id, qty: qty - 1 },
        config
      )
      .then((res) => setData1(res.data.cartItems));
  };

  const handleRemove = (id) => {
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    axios
      .post(
        `https://violent-hope.onrender.com/api/cart/remove`,
        { cartProID: id },
        config
      )
      .then((res) =>
        toast({
          description: "Product removed",
          status: "error",
          duration: 3500,
          isClosable: true,
        })
      )
      .then((res) => handleGet());
  };

  if (dataLoading) {
    return (
      <Flex
        alignItems="center"
        justifyContent="center"
        height={["40vh", "60vh", "70vh"]}
        width="100%"
      >
        <Dna
          visible={true}
          height="100%"
          width="100%"
          ariaLabel="dna-loading"
          wrapperStyle={{
            filter: "grayscale(100%)",
          }}
          wrapperClass="dna-wrapper"
        />
      </Flex>
    );
  }

  return (
    <>
      <Box
        onClick={() => navigate("/cart/delivery")}
        width={"95%"}
        margin="auto"
        flexDir={["column", "row", "row"]}
        display={"flex"}
        alignItems="center"
        border="1px solid white"
        justifyContent={"space-between"}
        marginBottom="20px"
      >
        <Text>YOUR SHOPPING BAG</Text>
        <Box
          cursor={"pointer"}
          boxSizing="border-box"
          border={"1px solid white"}
          display={["none", "inline-block", "inline-block"]}
          p={3}
          color={"white"}
          bg="black"
          fontSize="13px"
          align="center"
          w="200px"
        >
          PROCEED TO CHECKOUT
        </Box>
      </Box>
      <Box display={["none", "flex", "flex"]} m="0px 50px" h={"30px"}>
        <Box w={"15%"}></Box>
        <Box w={"58%"}></Box>
        <Box
          w={"9%"}
          h={"100%"}
          fontSize={["7px", "7px", "13px"]}
          fontWeight={650}
          display="flex"
          alignItems={"center"}
          justifyContent="center"
        >
          PRICE
        </Box>
        <Box
          w={"9%"}
          h={"100%"}
          fontSize={["7px", "7px", "13px"]}
          fontWeight={650}
          display="flex"
          alignItems={"center"}
          justifyContent="center"
        >
          QUANTITY
        </Box>
        <Box
          w={"9%"}
          h={"100%"}
          fontSize={["7px", "7px", "13px"]}
          fontWeight={650}
          display="flex"
          alignItems={"center"}
          justifyContent="center"
        >
          SUBTOTAL
        </Box>
      </Box>
      <Divider w={"90%"} m="auto" />

      {data1.map((elem) => (
        <CartCard
          key={elem._id}
          brand={elem.product.brand}
          title={elem.product.title}
          image={elem.product.image}
          price={elem.product.price}
          qty={elem.quantity}
          id={elem._id}
          handleplus={handleplus}
          handleminus={handleminus}
          handleRemove={handleRemove}
          itemnumber={elem.product.itemNo}
        />
      ))}

      <Cartmisc subtotal={subtotal} />
      <Contactcart />
    </>
  );
};

export default Cart;
